<section class="content">
  <div class="card" style="padding: 24px;">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
  <div class="row" style="text-align: center;">
    <div class="col-4">
      <button mat-button class="button-class">
        Change All Time For Mor - &nbsp;<input atp-time-picker  type="button" [(ngModel)]="mor_route_time"
          style="background: blanchedalmond;" #mor_value (ngModelChange)="changeAllRoute(1)">
      </button>
    </div>
    <div class="col-4">
      <button mat-button class="button-class">
        Change All Time For Eve - &nbsp;<input atp-time-picker  type="button" [(ngModel)]="eve_route_time"
          style="background: blanchedalmond;" #eve_value (ngModelChange)="changeAllRoute(2)">
      </button>
    </div>
  </div><br>
  <div class="container-fluid">
    <div *ngIf="!data_loaded">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [value]="value">
      </mat-progress-spinner>
    </div>
    <span *ngIf="data_loaded">
      <div class="row">
        <div class="col-8">
          <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" style="width: 100%;">
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: silver;"> SL.No</th>
              <td mat-cell *matCellDef="let element;let i = index"> {{i+1}}</td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                style="background: silver;height: 110px; top: 0px; position: sticky; z-index: 100;"> Name
                <div class="form-group" style="position: absolute; padding-top: 37px;">
                  <input type="text" [formControl]="nameFilter" class="form-control" placeholder="search"
                    style="border: 1px solid #888888; width: 70%; border-radius: 8px; margin-top: 46px; margin-left: -7px; height: 31px; text-align: inherit;">
                </div>
              </th>
              <td mat-cell *matCellDef="let element">{{element.name}}</td>
            </ng-container>

            <ng-container matColumnDef="order_expiry_time">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: silver;"> Order Expiry Time

              </th>
              <td mat-cell *matCellDef="let element">
                <div class="row">
                  <div class="col">
                    <!-- <input atp-time-picker [ngModel]="'2020-01-01:' + element.order_expiry_time | date: 'shortTime'" (ngModelChange)="timeValueChanged(element)"> -->
                    <input atp-time-picker [(ngModel)]="element.order_expiry_time"
                      (ngModelChange)="timeValueChanged(element)">
                  </div>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="union">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: silver;"> Union

              </th>
              <td mat-cell *matCellDef="let element">
                <div class="row">
                  <div class="col">
                    {{element.union}}
                  </div>

                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="session">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: silver;"> Session</th>
              <td mat-cell *matCellDef="let element">
                <div class="row">
                  <div class="col">
                    {{element.session_name}}
                  </div>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
      </div>
    </span>
  </div>
  </div>
</section>
